<!-- main content start -->
<div class="main-content">
    <div class="row g-4">
        <div class="col-12">
            <div class="panel">
                <div class="panel-header">
                    <h5>All Products</h5>
                    <div class="btn-box d-flex flex-wrap gap-2">
                        <div id="tableSearch"></div>
                        <button class="btn btn-sm btn-icon btn-outline-primary"><i
                                class="fa fa-arrows-rotate"></i></button>
                        <!-- <div class="digi-dropdown dropdown">
                            <button class="btn btn-sm btn-icon btn-outline-primary" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"><i class="fa fa-ellipsis-vertical"></i></button>
                            <ul class="digi-dropdown-menu dropdown-menu">
                                <li class="dropdown-title">Show Table Title</li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showProduct" checked>
                                        <label class="form-check-label" for="showProduct">
                                            Products
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showPublished" checked>
                                        <label class="form-check-label" for="showPublished">
                                            Published
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showStock" checked>
                                        <label class="form-check-label" for="showStock">
                                            Stock
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showPrice" checked>
                                        <label class="form-check-label" for="showPrice">
                                            Price
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showSales" checked>
                                        <label class="form-check-label" for="showSales">
                                            Sales
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showRating" checked>
                                        <label class="form-check-label" for="showRating">
                                            Rating
                                        </label>
                                    </div>
                                </li>
                                <li class="dropdown-title pb-1">Showing</li>
                                <li>
                                    <div class="input-group">
                                        <input type="number" class="form-control form-control-sm w-50" value="10">
                                        <button class="btn btn-sm btn-primary w-50">Apply</button>
                                    </div>
                                </li>
                            </ul>
                        </div> -->
                        <div class="btn-box">
                            <a class="btn btn-sm btn-primary" (click)="openAddProductModal('isNew')"><i
                                    class="fa fa-plus"></i> Add New</a>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <div class="table-filter-option mb-3">
                        <div class="row g-3">
                            <div class="col-xl-4 col-md-6">
                                <input type="text" class="form-control form-control-sm"
                                    placeholder="Search by title or SKU" (input)="onSearch($event)">
                            </div>
                            <div class="col-xl-2 col-md-6">
                                <select class="form-control form-control-sm" (change)="onCategoryChange($event)">
                                    <option value="all">All Categories</option>
                                    @for (cat of categoryOptions; track $index) {
                                    <option [value]="cat">{{cat}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-xl-2 col-md-6">
                                <select class="form-control form-control-sm" (change)="onStockChange($event)">
                                    <option value="all">All Stock</option>
                                    <option value="in">In stock</option>
                                    <option value="out">Out of stock</option>
                                    <option value="backorder">Backorder</option>
                                </select>
                            </div>
                            <div class="col-xl-2 col-md-6">
                                <select class="form-control form-control-sm" (change)="onSortChange($event)">
                                    <option value="newest">Newest</option>
                                    <option value="price_asc">Price: Low to High</option>
                                    <option value="price_desc">Price: High to Low</option>
                                    <option value="title_asc">Title: A-Z</option>
                                    <option value="title_desc">Title: Z-A</option>
                                </select>
                            </div>
                            <!-- <div class="col-xl-1 col-md-6">
                                <input type="number" class="form-control form-control-sm" placeholder="Min"
                                    (input)="onMinPriceChange($event)">
                            </div> -->
                            <!-- <div class="col-xl-1 col-md-6">
                                <input type="number" class="form-control form-control-sm" placeholder="Max"
                                    (input)="onMaxPriceChange($event)">
                            </div> -->
                            <div class="col-12 d-flex justify-content-end">
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    (click)="clearFilters()">Clear Filters</button>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="product-table-quantity">
                        <ul>
                            <li class="text-white">All (23)</li>
                            <li>Published (19)</li>
                            <li>Draft (05)</li>
                            <li>Trush (05)</li>
                        </ul>
                    </div>
                    <div class="table-filter-option">
                        <div class="row g-3">
                            <div class="col-xl-10 col-9 col-xs-12">
                                <div class="row g-3">
                                    <div class="col">
                                        <form class="row g-2">
                                            <div class="col">
                                                <select class="form-control form-control-sm"
                                                    data-placeholder="Bulk action">
                                                    <option value="">Bulk action</option>
                                                    <option value="0">Edit</option>
                                                    <option value="1">Move To Trash</option>
                                                </select>
                                            </div>
                                            <div class="col">
                                                <button class="btn btn-sm btn-primary w-100">Apply</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="col">
                                        <select class="form-control form-control-sm">
                                            <option value="0">All Category</option>
                                            <option value="1">Cloth</option>
                                            <option value="2">Fashion</option>
                                            <option value="3">Bag</option>
                                            <option value="4">Food</option>
                                            <option value="5">Medicine</option>
                                            <option value="6">Watch</option>
                                            <option value="7">Smart Phone</option>
                                        </select>
                                    </div>
                                    <.!-- <div class="col">
                                        <select class="form-control form-control-sm">
                                            <option value="0">All Product Type</option>
                                            <option value="1">Downloadable</option>
                                            <option value="2">Virtual</option>
                                        </select>
                                    </div> --.>
                                    <div class="col">
                                        <select class="form-control form-control-sm">
                                            <option value="0">All Product Stock</option>
                                            <option value="1">In stock</option>
                                            <option value="2">Out of stock</option>
                                            <option value="3">On backorder</option>
                                        </select>
                                    </div>
                                    <.!-- <div class="col">
                                        <button class="btn btn-sm btn-primary"><i class="fa fa-filter"></i> Filter</button>
                                    </div>
                                    <div class="col">
                                        <div class="digi-dropdown dropdown">
                                            <button class="btn btn-sm btn-icon btn-primary" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"><i class="fa fa-plus"></i></button>
                                            <ul class="digi-dropdown-menu dropdown-menu">
                                                <li class="dropdown-title">Filter Options</li>
                                                <li>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" id="filterCategory" checked>
                                                        <label class="form-check-label" for="filterCategory">
                                                            Category
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" id="filterProductType" checked>
                                                        <label class="form-check-label" for="filterProductType">
                                                            Product Type
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" id="filterStock" checked>
                                                        <label class="form-check-label" for="filterStock">
                                                            Stock
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> --.>
                                </div>
                            </div>
                            <div class="col-xl-2 col-3 col-xs-12 d-flex justify-content-end">
                                <div id="productTableLength"></div>
                            </div>
                        </div>
                    </div> -->
                    <div class="table-responsive">
                        <table class="table table-dashed table-hover digi-dataTable all-product-table table-striped"
                            id="allProductTable">
                            <thead>
                                <tr>
                                    <!-- <th class="no-sort">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="markAllProduct">
                                        </div>
                                    </th> -->
                                    <th>Product</th>
                                    <th>SKU</th>
                                    <th>Stock</th>
                                    <th>Price</th>
                                    <th>Sales</th>
                                    <th class="d-none">Rating</th>
                                    <th>Published</th>
                                    <th class="position-sticky end-0">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for(item of filteredProducts; track $index){
    
                                <tr>
                                    <!-- <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td> -->
                                    <td>
                                        <div class="table-product-card">
                                            @if(item && item.images.length>0){
    
                                            <div class="part-img">
                                                <img [src]="item?.images[0]?.url" alt="Image">
                                            </div>
                                            }
                                            <div class="part-txt">
                                                <span class="product-name">{{item.title}}</span>
                                                <span class="product-category">{{item.category.name}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{item.sku}}</td>
                                    <td>{{item.inventory.manageStock}}</td>
                                    <td>{{item.price_data.regularPrice}}</td>
                                    <td>{{item.price_data.salePrice}}</td>
                                    <td class="d-none">
                                        <div class="rating">
                                            <div class="star">
                                                <i class="fa-sharp fa-solid fa-star starred"></i>
                                                <i class="fa-sharp fa-solid fa-star starred"></i>
                                                <i class="fa-sharp fa-solid fa-star starred"></i>
                                                <i class="fa-sharp fa-solid fa-star starred"></i>
                                                <i class="fa-sharp fa-solid fa-star"></i>
                                            </div>
                                            <div class="rating-amount">(42)</div>
                                        </div>
                                    </td>
                                    <td>{{item.published_at}}</td>
                                    <td  class="position-sticky end-0">
                                        <div class="btn-box">
                                            <button type="button" (click)="previewProduct(item)"><i class="fa fa-eye" ngbTooltip="Preview" placement="top"></i></button>
                                            <button type="button" (click)="editoProduct(item)"><i class="fa fa-pen" ngbTooltip="Edit" placement="top"></i></button>
                                            <button type="button" (click)="cloneProduct(item)" ngbTooltip="Copy" placement="top"><i class="fa fa-copy"></i></button>
                                            <button type="button" class="text-danger" (click)="openDialog(item.id)" ngbTooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                }
    
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex align-items-center justify-content-end gap-1 py-2">
                        @for (page of productListData?.meta?.links; track $index) {
                        <button type="button" class="btn" (click)="nextPage(page.page)">
                            <span [innerHTML]="page.label"></span>
                        </button>
                        }
                    </div>
                    <!-- <div class="table-bottom-control">
                        <div>{{productListData.meta.current_page}}-{{productListData.meta.last_page}}</div>
                        <span (click)="nextPage(productListData.meta.current_page)">Next</span>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- main content end -->












<!-- return [
            'title'          => 'required|string|max:255',
            'slug'           => 'nullable|string|unique:products,slug',
            'category_id'    => 'required|exists:categories,id',
            'brand_id'       => 'nullable|exists:brands,id',
            'description'    => 'nullable|string',

            'inventory'      => 'nullable|array',
            'inventory.sku'  => 'nullable|string|unique:products,sku',

            'price_data'     => 'required|array',
            'price_data.regularPrice' => 'required|numeric|min:0',
            'price_data.salePrice'    => 'nullable|numeric|lte:price_data.regularPrice',

            'shipping_info'  => 'nullable|array',
            'shipping_config'=> 'nullable|array',
            'offer'          => 'nullable|array',
            'media'          => 'nullable|array',
            'tags'           => 'nullable|array',

            'seo'            => 'nullable|array',
            'seo.metaTitle'  => 'nullable|string|max:255',
            'seo.metaDscr'   => 'nullable|string',
            'seo.focusKeyphrase' => 'nullable|string',
            'seo.slugText'   => 'nullable|string',

            'visibility'     => 'nullable|array',
            'visibility.status' => 'nullable|in:0,1',
            'visibility.publishDate' => 'nullable|date',
        ]; -->
